a.button {
  align-items: center;
  align-self: center;
  background: none;
  border: 0;
  border-radius: var(--border-radius-button);
  cursor: pointer;
  display: inline-flex;
  font-size: 0.75rem;
  font-weight: bold !important;
  height: 2.5rem;
  justify-content: center;
  line-height: 1.3333;
  padding: 0;
  text-align: center;
  text-decoration: none;

  &:not(.icon) {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  &:hover {
    background-color: rgb(var(--colour-interactive-subtle-bg-hover));
    color: rgb(var(--colour-text-and-icon-1));
    text-decoration: none;
  }

  &.icon {
    height: 2.5rem;
    width: 2.5rem;
  }
}
